import React, { Component } from 'react';
import BasicExampleDataGrid from './DataGrid'
import { LineColumnChart } from "./General/LineColumnChart"
import { BarChart } from "./General/BarChart"
import { DonutChart } from "./General/DonutChart"
import { SparkLine } from "./General/SparkLine"
import { Button } from 'reactstrap';
import * as XLSX from 'xlsx/xlsx.mjs';

import authService from './api-authorization/AuthorizeService'
import { HomeProveedor_Index } from './HomeProveedor/HomeProveedorIndex';
import { HomeAdmin_Index } from './HomeAdmin/HomeAdminIndex';

export class Home extends Component {
    static displayName = Home.name;
    async reportTest() {
        const token = await authService.getAccessToken();
        //const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/reports/TestPDF', {
            method: 'GET',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        })
            .then(response => response.blob())
            .then(blob => {
                console.log("asdasfa")
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = "test.html";
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove();  //afterwards we remove the element again         
            });
    }
    constructor(props) {
        super(props);
        var today = new Date();
        var week = today.getWeek().toString();
        var year = today.getFullYear().toString();
        this.state = {
            reporteDespachoData: [],
            loading: true,
            role: "",
        };
        this.getRole = this.getRole.bind(this);
        this.populateData = this.populateData.bind(this);
    }
    componentDidMount() {
        this.populateData();
    }
    render() {
        const mystyle = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };
        return (

            <div>
                {this.state.role == "Admin" ?
                    //<div class="content-area">
                    //    <div class="container-fluid">
                    //        <div class="text-right mt-3 mb-3 d-fixed">

                    //        </div>
                    //        <div class="main">
                    //            <div class="row sparkboxes mt-4 mb-4">
                    //                <div class="col-md-6">
                    //                    <div class="box box1">
                    //                        <h1>Bienvenido!</h1>
                    //                        <p>Dashboard en construccion</p>
                    //                    </div>
                    //                </div>
                    //                {/*<div class="col-md-4">*/}
                    //                {/*    <div class="box box3">*/}
                    //                {/*        <div id="spark3"></div>*/}
                    //                {/*    </div>*/}
                    //                {/*</div>*/}
                    //                <div class="col-md-6">
                    //                    <div class="box box2">
                    //                        <SparkLine />
                    //                    </div>
                    //                </div>

                    //            </div>

                    //            {/*<div class="row mt-5 mb-4">*/}
                    //            {/*    <div class="col-md-3">*/}
                    //            {/*        <div class="box">*/}
                    //            {/*            <DonutChart />*/}
                    //            {/*        </div>*/}
                    //            {/*    </div>*/}
                    //            {/*    <div class="col-md-3">*/}
                    //            {/*        <div class="box">*/}
                    //            {/*            <BarChart/>*/}
                    //            {/*        </div>*/}
                    //            {/*    </div>*/}

                    //            {/*</div>*/}
                    //            <br />
                    //            <div class="row mt-4 mb-4">
                    //                <div class="box">
                    //                    <LineColumnChart />
                    //                </div>
                    //            </div>
                    //        </div>
                    //    </div>
                    //</div>
                    <HomeAdmin_Index/>
                    : this.state.role == "Proveedor" ? <HomeProveedor_Index /> : <div />}
            </div>
        );
    }
    async populateData() {
        this.setState({ loading: true, role: await this.getRole() }, async () => {
          
        });
    }
    async getRole() {
        const token = await authService.getAccessToken();

        const response = await fetch('api/Usuarios/GetRole', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        return await response.text();
    }
}
